import React, { useState, useEffect } from 'react';
import { UserOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import './TestimonialSection.css';

const testimonials = [
  { text: 'The events are always well-organized, and the atmosphere is amazing. I look forward to them every year!', name: 'Emily R.' },
  { text: 'The ticketing process was seamless, and I loved that I could get my tickets instantly on my phone.', name: 'John M.' },
  { text: 'Great event! Everything from the food to the music was top-notch. Definitely recommend attending.', name: 'Sophia L.' },
  { text: 'I appreciated how secure and easy it was to book tickets online. A fantastic experience overall!', name: 'David K.' },
  { text: 'The Lorrie Morgan concert was unforgettable. Thank you for organizing such a wonderful event.', name: 'Sarah T.' },
  { text: 'Being able to scan my ticket at the entrance made everything so much easier. Very impressed!', name: 'Michael B.' },
];

function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [isMobile]);

  const prev = () => setCurrent((c) => (c - 1 + testimonials.length) % testimonials.length);
  const next = () => setCurrent((c) => (c + 1) % testimonials.length);

  return (
    <div className="testimonial-section">
      <h2 className="testimonial-heading" data-aos="fade-up">What People Are Saying</h2>

      {isMobile ? (
        <div className="testimonial-slider">
          <div className="testimonial-slide">
            <div className="testimonial-card">
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">"{testimonials[current].text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar"><UserOutlined /></div>
                <span className="author-name">{testimonials[current].name}</span>
              </div>
            </div>
          </div>
          <div className="testimonial-controls">
            <button className="testimonial-arrow" onClick={prev}><LeftOutlined /></button>
            <div className="testimonial-dots">
              {testimonials.map((_, i) => (
                <span key={i} className={`testimonial-dot ${i === current ? 'active' : ''}`} onClick={() => setCurrent(i)} />
              ))}
            </div>
            <button className="testimonial-arrow" onClick={next}><RightOutlined /></button>
          </div>
        </div>
      ) : (
        <div className="testimonial-track">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card" data-aos="fade-up" data-aos-delay={i * 60}>
              <div className="testimonial-stars">★★★★★</div>
              <p className="testimonial-text">"{t.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar"><UserOutlined /></div>
                <span className="author-name">{t.name}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default TestimonialSection;